import { checkPermissions } from "@elit-hair/elit-tools";

/**
 * Extended function to check user permissions
 *
 * @param userPermissions Array of user permission codes
 * @param requiredPermissions Array of required permission codes
 * @returns true if user has access, false otherwise
 */
export const checkUserPermissions = (userPermissions: string[] = [], requiredPermissions: string[] = []): boolean => {
    // If no permissions are required, allow access
    if (!requiredPermissions || requiredPermissions.length === 0) {
        return true;
    }

    // Only check normal permissions
    return checkPermissions(userPermissions, requiredPermissions);
};
